module.exports = __webpack_public_path__ + "a86126fcb74aec374fbee35842d2f9b6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-19.png
// module id = 1667
// module chunks = 0